<template>
  <div>
    <main role="primary">
      <div class="pane" :class="{animate: animateTransition}"></div>
      <transition name="fade" mode="out-in">
      <div class="mxr-touch" @click="animTouch = false" v-if="animTouch">
        <div class="mxr-touch__anim">
          <img src="../assets/img/swipe_leftright.svg" alt="" width="50">
        </div>
        <p>Sfoglia lateralmente <br>per scoprire gli outfits</p>
      </div>
      </transition>
      <flickity ref="flickity" :style="{height: `${sectionHeight}px`}" :class="`mxr-slider-looks m-slider-looks--${gender}`" :options="flickityOptions">
        <div class="cell" :style="{height: `${sectionHeight}px`}" :data-src="look.images.large" :data-color="look.hex_color" :key="(index)" v-for="(look, index) in looks[gender]">
          <div class="pane" :data-look="(index)" :style="{background: `linear-gradient(145deg, ${hexToRGB(look.hex_color, 0)} 40%,${hexToRGB(look.hex_color, 0.15)} 50%,${hexToRGB(look.hex_color, 1)} 100%) 0 1000px no-repeat`}"></div>
            <div class="mxr-slider-looks__title">
              <div class="type">Outfit</div>
              <div class="num">#{{index | padToTwo}}</div>
            </div>
          <div class="cell__inner" :style="{height: `${sectionHeight}px`}" :data-look="(index)" :data-flickity-bg-lazyload="look.images.large">
          </div>
        </div>
      </flickity>
    </main>
    <borders :show-corners="false" :showGender="gender" :prevArrow="true" :nextArrow="true" :show-text="false" :show-dots="false"></borders>
  </div>
</template>

<script>
  import borders from '@/components/Borders';
  import Flickity from 'vue-flickity';
  import 'flickity-imagesloaded';
  import 'flickity-bg-lazyload';
  import utils from '../utils';

  export default {
    name: 'looks',
    components: {
      borders,
      Flickity,
    },
    head: {
      title() {
        return {
          inner: 'Kalenji by Decathlon',
          separator: '–',
          complement: `Looks ${this.genderType}`,
        };
      },
      meta() {
        return [
          { name: 'description', content: `Collection Automne-Hiver 2017 - looks ${this.genderType}` },
        ];
      },
    },
    data() {
      return {
        gender: this.$route.params.gender,
        looks: this.$root.looks,
        animateTransition: false,
        sectionHeight: '',
        animTouch: false,
        flickityOptions: {
          initialIndex: 0,
          setGallerySize: true,
          imagesLoaded: true,
          percentPosition: true,
          groupCells: '100%',
          bgLazyLoad: 2,
          contain: false,
          prevNextButtons: false,
          pageDots: true,
          wrapAround: true,
          accessibility: true,
        },
      };
    },
    computed: {
      genderType() {
        let gender = '';
        if (this.gender === 'men') {
          gender = 'Uomo';
        } else if (this.gender === 'women') {
          gender = 'Donna';
        }
        return gender;
      },
    },
    methods: {
      hexToRGB(val, alpha) {
        const r = parseInt(val.slice(1, 3), 16);
        const g = parseInt(val.slice(3, 5), 16);
        const b = parseInt(val.slice(5, 7), 16);
        let color = '';
        const a = alpha;

        if (a !== '') {
          color = `rgba(${r},${g},${b},${a})`;
        } else {
          color = `rgb(${r},${g},${b})`;
        }
        return color;
      },
      setAnimTouch() {
        if (utils.isTouchDevice()) {
          this.animTouch = true;
        }
        setTimeout(() => {
          this.animTouch = false;
        }, 2500);
      },
    },
    mounted() {
      /* if (this.$route.hash !== '') {
        const hash = parseInt(this.$route.hash.substring(1), 10);
        this.$refs.flickity.select(hash, false, true);
      }*/
      this.$store.commit('hideCart');
      this.$store.commit('showBorders');
      /* this.$refs.flickity.on('settle', () => {
        history.pushState(null, null, `#${this.$refs.flickity.selectedIndex()}`);
      });*/
      this.$refs.flickity.on('staticClick', (e) => {
        const lookId = e.target.getAttribute('data-look');
        this.animateTransition = true;
        setTimeout(() => {
          this.$router.push({ path: `/looks/${this.gender}/${lookId}` });
        }, 1100);
        this.$gtm.trackEvent({
          event: 'lookClick',
          category: 'Interactions',
          action: 'click',
          label: 'Look visit',
          lookGender: this.gender,
          lookId: `Look ${lookId}`,
        });
      });
      this.sectionHeight = utils.getBorderedViewport();
      this.setAnimTouch();
    },
    updated() {
      this.$root.$on('posSlider', (value) => {
        if (value === 'next') {
          this.$refs.flickity.next();
        } else if (value === 'prev') {
          this.$refs.flickity.previous();
        }
      });
    },
    beforeDestroy() {
      this.$root.$off('posSlider');
    },
  };
  </script>

  <style lang="scss" scoped>
    .pane {
      top: 0;
      left: 0;
      bottom: 0;
      width: 0;
      height: 100%;
      z-index: 2;
      position: absolute;
      display: flex;
      align-items: center;
      /* span {
        font-size: rem-calc(400);
        font-family: $body-font-family-alt;
        font-weight: $global-weight-bold;
        font-style: italic;
        position: absolute;
      } */
      &:before {
        content: '';
        position: absolute;
        background: $white;
        transform: skewX(10deg);
        top: 0;
        left: 0;
        bottom: 0;
        width: 0vw;
        height: 100%;
        z-index: 2;
        transform-origin: 0 100%;
        transition: width .9s cubic-bezier(0.745, 0.200, 0.080, 0.970);
      }

      &.animate {
        &:before {
          width: 130vw;
        }
      }
    }
    .mxr-slider-looks {
      .cell {
        // height: rem-calc(624);
        width: 100%;
        display: flex;
        filter: grayscale(0);
        overflow: hidden !important;
          
        .pane {
          content: '';
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          bottom: 0;
          right: 0;
          opacity: 0;
          z-index: 1;
          transition: opacity .4s cubic-bezier(0.745, 0.200, 0.080, 0.970) .4s, box-shadow .5s cubic-bezier(0.745, 0.200, 0.080, 0.970), background-position 1s cubic-bezier(0.745, 0.200, 0.080, 0.970) 0s;
        }
        &:hover {
          .cell__inner {
            filter: grayscale(1);
            box-shadow: inset rem-calc(0 0 0 20) $white;
          }
          .mxr-slider-looks__title {
            margin-top: rem-calc(-120);
            opacity: 1;
            .type {
              animation: moveRightText 1s cubic-bezier(0.745, 0.200, 0.080, 0.970) forwards;
            }
            .num {
              animation: moveRightText 1.2s cubic-bezier(0.745, 0.200, 0.080, 0.970) forwards;
            }
          }
          .pane {
            opacity: 1;
            box-shadow: inset rem-calc(0 0 0 20) $white;
            background-position: 0 0 !important;
          }
        }
        @include breakpoint(medium) {
          width: 32%
        }
        @include breakpoint(large) {
          width: 23%
        }
        
        &__inner {
          height: 100%;
          width: 100%;
          opacity: 0;
          box-shadow: inset 0 0 0 0 $white;
          transition: box-shadow cubic-bezier(0.745, 0.200, 0.080, 0.970) .4s, filter ease .6s;
          transition-delay: .1s;      
          background-size: cover;
          background-repeat: no-repeat;
          background-position: center center;
          &.flickity-bg-lazyloaded {
            opacity: 1
          }
        }
      }

      &__title {
        display: flex;
        opacity: 0;
        flex-direction: column;
        align-items: center;
        position: absolute;
        top: 100%;
        margin-top: rem-calc(0);
        left: 0;
        right: 0;
        transition: all cubic-bezier(0.745, 0.200, 0.080, 0.970) .5s;
        transition-delay: .1s;
        transform: translateZ(0);
        z-index: 2;
        .type {
          color: $white;
          text-transform: uppercase;
          font-size: rem-calc(16);
          letter-spacing: .711em;
          margin-right: rem-calc(-.711em);
          font-weight: bold;
        }
        .num {
          font-size: rem-calc(140);
          color: $white;
          font-family: $body-font-family-alt;
          font-weight: bold;
          font-style: italic;
          letter-spacing: -.05em;
          line-height: .86;
        }
      }
    }
    .mxr-touch {
      position: absolute;
      background: rgba(black, .8);
      height: 100vh;
      width: 100vw;
      z-index: 2;
      top: 0;
      left: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      flex-direction: column;

      &__anim {
        margin-bottom: rem-calc(20);
        animation: slideFinger 2s ease infinite;
        @at-root {
          @keyframes slideFinger {
            0% {
              opacity: 0;
              transform: translateX(rem-calc(50));
            }
            15% {
              transform: translateX(rem-calc(50));
              opacity: 1;
            }
            75% {
              transform: translateX(rem-calc(-50));
            }
            100% {
              opacity: 0;
              transform: translateX(rem-calc(-50));
            }
          }
        }
      }

      p {
        color: $white;
      }
    }
  </style>



// WEBPACK FOOTER //
// Looks.vue?33caeac4